import { ResourceProps } from "react-admin";
import Icon from "@mui/icons-material/NightShelter";
import { Resource } from "../../enums";
import ListScreen from "./list";
import { EditScreen } from "./edit";

const aboutUsPages: ResourceProps = {
  name: Resource.ABOUT_US_PAGES,
  icon: Icon,
  list: ListScreen,
  edit: EditScreen,
  options: {
    label: "About Us",
  },
};

export default aboutUsPages;
